import {BaseAttribute} from "@/pages/AppPages/Events/attribute";

export class MarkingEventAttributes extends BaseAttribute {

    constructor(initObjectParams) {
        super(initObjectParams);
        this.dbName = null;
        this.chipId = null;
        this.labelId = null;
        this.markingSpecialist = null;
        this.markingSpecialistPosition = null;
        this.conclusion = null;

        if (initObjectParams && initObjectParams.chipId) {
            this.chipId = initObjectParams.chipId;
        }

        if (initObjectParams && initObjectParams.labelId) {
            this.labelId = initObjectParams.labelId;
        }
    }

    static get modelName() {
        return 'ClinicalEvent'
    }

    static get validations() {
        return {
            dbName: {},
            chipId: {},
            labelId: {},
            markingSpecialist: {},
            markingSpecialistPosition: {},
            conclusion: {}
        }
    }

    static get validationFieldLabels() {
        return {
            dbName: 'База данных',
            chipId: 'Чип',
            labelId: 'Бирка',
            markingSpecialist: 'Ветеринарный специалист',
            markingSpecialistPosition: 'Должность',
            conclusion: 'Заключение'
        }
    }

    static get mapping() {
        // Костыль для сохранения обратной совместимости с предыдущим именем атрибута.
        // Введен в связи с необходимостью отображать столбец "Вет. спец." в таблице клинических мероприятий
        return {
            'markingSpecialist': 'vetSpecialist'
        }
    }

    static get label() {
        return ''
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    applyData(data) {
        this.dbName = data['dbName'];
        this.chipId = data['chipId'];
        this.labelId = data['labelId'];
        this.markingSpecialist = data['vetSpecialist'] ? data['vetSpecialist'] : data['markingSpecialist'];
        this.markingSpecialistPosition = data['markingSpecialistPosition'];
        this.conclusion = data['conclusion'];
    }

}